exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tsBg[data-v-acca93ac]{position:fixed;top:0;left:0;bottom:0;right:0;background-color:rgba(0,0,0,.6);z-index:1;text-align:center}.tsBg .tsContent[data-v-acca93ac]{margin:0 auto;margin-top:3rem;width:5.6rem;height:4.52rem;padding:.2rem .4rem;background:#fff;-webkit-box-shadow:0 0 10px 0 rgba(0,0,0,.2);box-shadow:0 0 10px 0 rgba(0,0,0,.2);border-radius:.12rem;font-size:.24rem;color:#19191a}.tsBg .tsContent h3[data-v-acca93ac]{font-weight:700;margin:.36rem auto}.tsBg .tsContent ul[data-v-acca93ac]{text-align:left;list-style-type:decimal;margin-left:.35rem;line-height:.36rem}.tsBg .closeBtn[data-v-acca93ac]{width:.6rem;height:.6rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-acca93ac","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/sign-up/components/rules.vue
// module id = Extw
// module chunks = 1